<template>
  <div>
    <transition name="component-fade" mode="out-in">
      <TrialLesson v-if="studentStatus==='trial'" ></TrialLesson>
      <Full v-if="studentStatus==='full'"></Full>
    </transition>
  </div>
</template>

<script>
  import TrialLesson from './trial/TrialLesson';
  import Full from './full/Full';

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Lesson',
    components: {
      TrialLesson,
      Full,
    },
    data: function () {
      return {
        // lessonStatus: 0,
      }
    },
    computed: {
      ...mapGetters({
        studentStatus: 'user/studentStatus',
      }),
    },
    mounted(){

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>

</style>
